import axios from 'axios';

import type {
  IForgotPasswordDataPayload,
  ILoginPayload,
  ILoginResponse,
  IRegisterPayload,
  IResetPassowrdPayload,
} from '@/interfaces/auth.interface';
import type { IHttpResponse } from '@/interfaces/http.interface';
import type { IResetPasswordUser } from '@/interfaces/user.interface';

import { baseURL } from '@/utils/constants';

// --- SignIn Service ---

export const signInUser = async (data: ILoginPayload): Promise<IHttpResponse<ILoginResponse>> => {
  const response = await axios.post(`${baseURL}/api/auth/login`, data);
  return response.data;
};

// --- Provider Login Service ---
export const signInWithProvider = async (
  accessToken: string,
  provider: string,
): Promise<IHttpResponse<ILoginResponse>> => {
  const response = await axios.post(`${baseURL}/api/auth/login/provider`, {
    accessToken: accessToken,
    provider: provider,
  });
  return response.data;
};

// --- Register Service ---

export const registerUser = async (data: IRegisterPayload) => {
  const response = await axios.post(`${baseURL}/api/auth/register`, data, {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

// --- Token Check Service ---
export const checkForgotPasswordToken = async (token: string): Promise<IHttpResponse<IResetPasswordUser>> => {
  const response = await axios.get(`${baseURL}/api/auth/check/${token}`, {
    headers: {
      Accept: '*/*',
    },
  });
  return response.data;
};

// --- Forgot Password Service ---
export const forgotPassword = async (data: IForgotPasswordDataPayload) => {
  const response = await axios.post(`${baseURL}/api/auth/forgot-password`, data, {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

// --- Reset Password Service ---
export const resetPassword = async (payload: IResetPassowrdPayload) => {
  const response = await fetch(`${baseURL}/api/auth/reset-password`, {
    method: 'POST',
    headers: {
      accept: '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (response.ok) {
    return true;
  }
};
